import React from "react";
import InfoIcon from "@material-ui/icons/Info";

import { useClickAway } from "react-use";

type IParams = React.PropsWithChildren<{
  severity?: "info" | "warning" | "error";
}>;

export const Todo = (props: IParams = { severity: "info" }) => {
  const [hover, setHover] = React.useState(false);

  const ref = React.useRef(null);
  useClickAway(ref, () => {
    setHover(false);
  });

  if (process.env.NODE_ENV !== "development") return null;

  return (
    <div style={{ position: "relative" }}>
      <div
        style={{
          background: "yellow",
          color: "black",
          border: "1px solid black",
          fontSize: "11px",
          borderRadius: "5px",
          display: "inline-flex",
          cursor: "pointer",
          justifyContent: "center",
          alignItems: "center",
          transform: "rotate(-2 deg)",
          zIndex: 22,
        }}
        onClick={() => {
          setHover((v) => !v);
        }}
      >
        <InfoIcon /> TODO
      </div>
      {hover ? (
        <div
          ref={ref}
          style={{
            position: "absolute",
            left: "30px",
            top: "30px",
            boxShadow: "0 5 10 #eee",
            padding: "10px",
            border: "1px solid gray",
            background: "white",
            zIndex: 33,
          }}
        >
          {props.children}
        </div>
      ) : null}
    </div>
  );
};

export default Todo;
